import React from 'react';

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100">
      {/* Background Image */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(/hero-image.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: 0.85
        }}
      />

      {/* Wave overlay at bottom */}
      <div className="absolute bottom-0 left-0 right-0 z-10">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full">
          <path
            d="M0 0C240 40 480 80 720 80C960 80 1200 40 1440 0V120H0V0Z"
            fill="white"
          />
        </svg>
      </div>

      {/* Decorative dots */}
      <div className="absolute top-20 left-10 opacity-20">
        <div className="grid grid-cols-3 gap-2">
          {[...Array(9)].map((_, i) => (
            <div key={i} className="w-2 h-2 rounded-full bg-[#1A4D4D]"></div>
          ))}
        </div>
      </div>

      {/* Main content */}
      <div className="relative z-20 flex items-center justify-center px-4 w-full">
        <div className="relative">
          {/* White circle background - smaller on mobile */}
          <div className="bg-white/95 backdrop-blur-sm rounded-full w-[280px] h-[280px] sm:w-[340px] sm:h-[340px] md:w-[500px] md:h-[500px] lg:w-[600px] lg:h-[600px] shadow-2xl flex items-center justify-center p-6 sm:p-8 md:p-12">
            <div className="text-center">
              {/* Heart illustration - smaller on mobile */}
              <div className="mb-2 sm:mb-4 md:mb-6 flex justify-center">
                <svg width="30" height="25" viewBox="0 0 60 50" fill="none" className="text-[#FF6347] sm:w-[40px] sm:h-[35px] md:w-[60px] md:h-[50px]">
                  <path
                    d="M30 45C30 45 5 30 5 15C5 5 15 5 20 10C25 15 30 20 30 20C30 20 35 15 40 10C45 5 55 5 55 15C55 30 30 45 30 45Z"
                    fill="currentColor"
                  />
                </svg>
              </div>

              <h2
                className="text-xs sm:text-sm md:text-xl lg:text-2xl text-gray-600 mb-1"
                style={{ fontFamily: 'Quicksand, sans-serif' }}
              >
                Een veilige plek voor
              </h2>
              <h1
                className="text-lg sm:text-xl md:text-4xl lg:text-5xl font-bold text-[#1A4D4D] mb-1 leading-tight"
                style={{ fontFamily: 'Fredoka, Quicksand, sans-serif' }}
              >
                structuur & ontwikkeling
              </h1>
              <h2
                className="text-xs sm:text-sm md:text-xl lg:text-2xl text-gray-600"
                style={{ fontFamily: 'Quicksand, sans-serif' }}
              >
                met warme begeleiding
              </h2>
            </div>
          </div>

          {/* Decorative illustrations around circle - hidden on mobile */}
          <div className="absolute -left-16 bottom-20 opacity-80 hidden md:block">
            <svg width="80" height="100" viewBox="0 0 80 100" fill="none">
              <ellipse cx="40" cy="30" rx="30" ry="35" fill="#FF9B7D" />
              <circle cx="40" cy="20" r="20" fill="#1A4D4D" />
              <rect x="25" y="55" width="30" height="40" rx="5" fill="#FFA07D" />
            </svg>
          </div>

          <div className="absolute -right-16 bottom-32 opacity-80 hidden md:block">
            <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
              <ellipse cx="40" cy="30" rx="25" ry="30" fill="#5DADE2" />
              <circle cx="40" cy="22" r="18" fill="#1A4D4D" />
              <rect x="28" y="50" width="24" height="28" rx="4" fill="#6DB8E8" />
            </svg>
          </div>

          {/* Floating colored dots - hidden on mobile */}
          <div className="absolute top-10 right-10 w-6 h-6 rounded-full bg-[#FFD580] animate-bounce hidden md:block"></div>
          <div className="absolute bottom-10 left-20 w-8 h-8 rounded-full bg-[#5DADE2] animate-pulse hidden md:block"></div>
          <div className="absolute top-32 -left-10 w-5 h-5 rounded-full bg-[#FF9B7D] animate-bounce hidden md:block" style={{ animationDelay: '0.5s' }}></div>
        </div>
      </div>

      {/* Decorative leaf */}
      <div className="absolute bottom-32 right-20 opacity-30 hidden lg:block">
        <svg width="40" height="60" viewBox="0 0 40 60" fill="none">
          <path
            d="M20 0C20 0 40 20 20 60C20 60 0 20 20 0Z"
            fill="#52BE80"
          />
        </svg>
      </div>
    </section>
  );
};

export default Hero;